import React, {Component} from 'react'
import { connect } from "react-redux";
import Odontograma from '../common/Odontograma'
import OdontogramaIRP from '../common/OdontogramaIRP'
import OdontogramaInfo from '../common/OdontogramaInfo'
import _ from 'lodash'
import {updateSteps, fetchSteps} from "../../actions";

class InfoContainer extends Component{
    constructor(props){
        super(props);
        this.state = {
            irp: [],
            attachments: [],
            notes: [],
            activeNote: ""
        }
    }
    attachesBuilder(props){
        const buidStateObject = () => {
            let data = _.filter(props.steps, {type: 1});
            data = _.map(_.groupBy(data,"step"), (item, key) =>{ return {step: key, value: item}} );
            return _.keyBy(data, "step");
        };
        this.setState({
            attachments: buidStateObject(),
            initialAttachments: buidStateObject()
        })
    }
    irpBuilder(props){
        const buildStateIrp = () => {
            let result = _.filter(props.steps, {type: 0});
            result = _.chain(result).groupBy("step").map(function (v, i){
                let subresult = _.keyBy(v, 'field');
                subresult = _.mapValues(subresult, function(o) { return o.value; });
                return {
                    step: i,
                    value: subresult
                }
            }).value();
            let dataSteps = _.keyBy(result, "step");
            return dataSteps;
        };
        this.setState({
            irp: buildStateIrp(),
        })
    }
    notesBuilder(props, prevStep, prevNote){
        const notesState = this.state.notes;
        const buildStateNote = () => {
            let notes = [];
            const currentValue = _.filter(props.steps, {
                type: 2,
                step: prevStep || this.props.activeStep})[0] && _.filter(props.steps, {
                type: 2,
                step: prevStep || this.props.activeStep})[0].value;
            const editNewCehcker = prevNote !==  undefined && currentValue !== prevNote;
            if((prevStep || prevStep === 0) && prevNote && editNewCehcker){
                const cachedNote = {
                    type: 2,
                    value: prevNote,
                    step: prevStep,
                    caso_id: this.props.caso.id,
                    field: "note"
                };
                const notesArray = notesState.length !== 0 ? notesState : _.filter(props.steps, {type: 2});
                notes = [...notesArray.filter(item => item.step !== prevStep), cachedNote];
            } else {
                // notes = notesState.length !== 0 ? notesState : _.filter(props.steps, {type: 2});
                notes = _.filter(props.steps, {type: 2});
            }
            return notes;
        };
        this.setState({
            notes: buildStateNote(),
            activeNote: _.filter(buildStateNote(), {step: this.props.activeStep})[0] ? _.filter(buildStateNote(), {step: this.props.activeStep})[0].value : ''
        });
    }
    printScreen(){
        window.print();
    }
    componentDidMount(){
        this.props.fetchSteps(this.props.caso.id);
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.props.steps !== prevProps.steps){
            this.attachesBuilder(this.props);
            this.irpBuilder(this.props);
            this.notesBuilder(this.props);
        }
        if(this.props.activeStep !== prevProps.activeStep){
            this.notesBuilder(this.props, prevProps.activeStep, prevState.activeNote);
        }
    }
    changeNoteValue(e){
        this.setState({activeNote: e.target.value})
    }
    saveChanges(){
        const attachesArray = Object.values(this.state.attachments)
            .reduce((acc, curr) => [...acc, ...curr.value], []);
        const irpArray = _.flatten(_.toArray(this.state.irp));
        let notesArray = _.flatten(_.toArray(this.state.notes));

        if(this.state.activeNote || this.state.activeNote === ""){
            notesArray = notesArray.filter(item => {
               return item.step !== this.props.activeStep
            });
            notesArray.push({
                step: this.props.activeStep,
                value: this.state.activeNote,
                type: 2
            })
        }

        this.props.updateSteps({
            attaches: attachesArray,
            irp: irpArray,
            notes: notesArray
        }, this.props.caso.id);
    }
    selectPiece(id, type, pieces, pieceClicked, piece){
        let newState = this.state[type];
        let total = this.props.caso && this.props.caso.modelos && this.props.caso.modelos.length && this.props.caso.modelos.length/2;
        let delPiece = false;
        if(type ==="attachments") {
            delPiece = this.state[type][this.props.activeStep] && this.state[type][this.props.activeStep].value.filter(item => item.value === piece).length !== 0;


            for (let i = Number(id); i < total; i++) {
                let newPieceClicked = [];
                for (let x = 0; pieceClicked.length > x; x++) {
                    newPieceClicked.push({
                        type: pieceClicked[x].type,
                        field: pieceClicked[x].field,
                        value: pieceClicked[x].value,
                        step: i
                    });
                }
                if (newState[i] && newState[i].value) {
                    let cachedValues = [];
                    if (delPiece) {
                        cachedValues = newState[i].value.filter(item => item.value !== piece);
                    } else {
                        cachedValues = newState[i].value;
                    }
                    newState[i].value = [...cachedValues, ...newPieceClicked];
                } else {
                    newState[i] = {
                        step: i,
                        value: newPieceClicked
                    }
                }
            }
        } else {
            newState[this.props.activeStep] = {
                step: id,
                value: pieces
            }
        }
        this.setState({[type]: newState});
    }
    render(){
        let message = this.state.notes.length !== 0 && this.state.notes.filter(item => { return item.step == this.props.activeStep })[0];
        message = message && message.value ? message.value : "";
        return(
            <div className="od-sidebar">
                <div className="row">
                    <div className="col-md-12">
                        <h4>Movimiento {Number(this.props.activeStep)}
                            <button onClick={this.printScreen.bind(this)} className="btn btn-link pull-right">
                                <i className="fa fa-print fa-1x" />
                            </button>
                        </h4>
                    </div>
                </div>
                {this.props.isAdmin ?
                    <input
                        name={`noteNum_${this.props.activeStep}`}
                        type="text"
                        className="col-md-12"
                        placeholder={`Escribe aquí la nota para el movimiento ${this.props.activeStep}`}
                        value={this.state.activeNote}
                        onChange={this.changeNoteValue.bind(this)}
                    />
                    :
                    message && <div className="alert alert-warning" role="alert"><strong>Nota:</strong> {message}</div>
                }
                <h5>Informe de Reducción Interproximal</h5>
                <OdontogramaIRP
                    id={Number(this.props.activeStep)}
                    type="irp"
                    selectPiece={this.selectPiece.bind(this)}
                    isEditable={this.props.isAdmin}
                    pieces={this.state.irp[this.props.activeStep] || []}
                />
                <span className="page-break" />
                <h5>Informe de Ataches</h5>
                <Odontograma
                    id={Number(this.props.activeStep)}
                    type="attachments"
                    selectPiece={this.selectPiece.bind(this)}
                    isEditable={this.props.isAdmin}
                    pieces={this.state.attachments[this.props.activeStep] || []}
                />
                <OdontogramaInfo />
                {this.props.isAdmin ? <button onClick={this.saveChanges.bind(this)} className="btn btn-primary">Guardar cambios</button> : <span></span>}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        steps: state.steps
    };
}

export default connect(mapStateToProps,
    {
        updateSteps,
        fetchSteps
    })(InfoContainer);



// WEBPACK FOOTER //
// ./resources/assets/js/components/casos/InfoContainer.jsx